import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { ApplicationState } from "../../store";
import * as httpClient from "../../util/httpClient";
import { useForm } from "react-hook-form";
import * as service from "../../store/service";
import * as ConfigurationActions from "../../store/configurationService/actions";
import NeedHelp from "./NeedHelp";
import RenderIcons from "../../Assets/css/_icons/partner_icon/RenderIcons";
import { useTranslation } from "react-i18next";

const ResetPassword = (props: any) => {
    const { t: tLang, i18n: i18nLang } = useTranslation();
    const dispatch = useDispatch();
    const preferredMethod = useSelector((state: ApplicationState) =>
        state.forgotPasswordState && state.forgotPasswordState.selectedMethod ? state.forgotPasswordState.selectedMethod : ""
    );
    const preferredCommunicationMedia = useSelector((state: ApplicationState) =>
        state.forgotPasswordState && state.forgotPasswordState.communicationMethodList ? state.forgotPasswordState.communicationMethodList : []
    );
    const partnerPhoneNumber: string = useSelector((state: ApplicationState) =>
        state.configurationState && state.configurationState.configuration.partnerConfig.phoneNumber
            ? state.configurationState.configuration.partnerConfig.phoneNumber
            : ""
    );
    const isLife360PartnerId = useSelector((state: ApplicationState) =>
        state.configurationState && state.configurationState.configuration.partnerConfig.partnerId
            ? state.configurationState.configuration.partnerConfig.partnerId === 539
                ? true
                : false
            : false
    );
    const routeLoading = useSelector((state: ApplicationState) => state.configurationState && (state.configurationState.loading || false));
    const [state, setState] = useState({ temporaryPassword: "", errorMessage: "", isAccountLockedOut: false, isLoading: false });
    const { register, errors, handleSubmit } = useForm({
        mode: "onSubmit",
        reValidateMode: "onChange",
    });
    const partnerLanguageOptions = useSelector(
        (state: ApplicationState) => state.configurationState && state.configurationState.partnerLanguageOptions && state.configurationState.partnerLanguageOptions
    );
    useEffect(() => {
        window.scrollTo(0, 0);
        setLanguage();
    }, []);

    useEffect(() => {
        if (routeLoading) {
            dispatch(ConfigurationActions.actionCreators.setRouteLoading(false));
        }
    }, [dispatch, routeLoading]);

    const setLanguage = () => {
        setTimeout(() => {
            let language =
                !!partnerLanguageOptions && partnerLanguageOptions.length > 1
                    ? document.cookie.split(";").filter((cookieElement: string) => cookieElement.split("=")[0].trim() == "user_prefered_language").length > 0
                        ? !!document.cookie
                            .split(";")
                            .filter((cookieElement: string) => cookieElement.split("=")[0].trim() == "user_prefered_language")[0]
                            .split("=")[1]
                            ? document.cookie
                                .split(";")
                                .filter((cookieElement: string) => cookieElement.split("=")[0].trim() == "user_prefered_language")[0]
                                .split("=")[1]
                            : "en"
                        : "en"
                    : "en";
            i18nLang.changeLanguage(language);
        });
    };
    const onSubmit = (data: any) => {
        window.addToDataLayer({ event: "Validate Temporary Password" });

        setState({ ...state, errorMessage: " ", isLoading: true });

        const requestBody = {
            password: data.temporaryPassword,
        };

        httpClient
            .sendRequest("POST", `web/forgot-password/validate-temporary-password`, requestBody)
            .then((data) => {
                setState({ ...state, isLoading: false });
                if (data["isValidUser"]) {
                    props.history.push("/reset-password");
                } else {
                    setState({ ...state, errorMessage: tLang("validatePassword.errorMessages.incorrectVerificationCode") });
                }

                if (data["accountLockedout"]) {
                    setState({ ...state, isAccountLockedOut: true });
                }
            })
            .catch(function (error) {
                setState({ ...state, isLoading: false });
            });
    };

    const handleChange = (e: any) => {
        e.preventDefault();
        if (state.errorMessage.length > 0) {
            setState({ ...state, errorMessage: "" });
        }
    };

    const maskedField = (field: any) => {
        if (preferredMethod && (preferredMethod === "SMS" || preferredMethod === "Call")) {
            let index = field.length - 4;
            let maskedFields = field.slice(0, index);
            return field.replace(maskedFields, "******");
        }
        return field;
    };

    const resendVerificationCode = () => {
        if (preferredCommunicationMedia && Array.isArray(preferredCommunicationMedia) && preferredCommunicationMedia.length >= 2) {
            props.history.push("/preferred-communication-option");
        } else {
            service
                .resendVerificationCode()
                .then((data) => {})
                .catch(() => {});
        }
    };

    return (
        <React.Fragment>
            <div id="l-page-content">
                <div className="l-page-container">
                    <div className=" row">
                        <div className="col-xs-12">
                            <h1 className="title-page sr-only" id="title-page" tabIndex={-1}>
                                {tLang("validatePassword.titlePage")}
                            </h1>
                        </div>
                    </div>
                    {state.isAccountLockedOut ? (
                        <div className="row margin-vertical-xl" id="content">
                            <div className="col-xs">
                                <div className="box box-has-shadow box-xs offset-padding">
                                    <div className="box-header">
                                        <div className="box-title-container">
                                            <div className="box-title-icon" aria-hidden="true">
                                                <RenderIcons iconName="key" />
                                            </div>
                                            <div className="box-title-text">
                                                <h2 className="box-title">{tLang("validatePassword.title")}</h2>
                                            </div>
                                        </div>
                                        <div className="box-description">
                                            <div className="form-row">
                                                <button
                                                    type="button"
                                                    className="btn-default btn-link btn-no-padding btn-no-border"
                                                    onClick={() => {
                                                        window.addToDataLayer({ event: "Back to Login" });
                                                        props.history.push("/");
                                                    }}
                                                >
                                                    <span className="btn-text">{tLang("validatePassword.backToLogin")}</span>
                                                </button>
                                            </div>
                                        </div>
                                    </div>
                                    <div className="box-content">
                                        <div className="form-row row">
                                            <div className="col-xs-12 col-no-gutter">
                                                <p>
                                                    {tLang("validatePassword.paragraph1")}{" "}
                                                    <a href={'tel:"' + partnerPhoneNumber + '"'}>{partnerPhoneNumber}</a>.{tLang("validatePassword.paragraph2")}
                                                </p>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    ) : (
                        <div className="row margin-vertical-xl" id="content">
                            <div className="col-xs">
                                <div className={state.isLoading ? "box box-has-shadow box-xs offset-padding loading" : "box box-has-shadow box-xs offset-padding"}>
                                    <div className="box-header">
                                        <div className="box-title-container">
                                            <div className="box-title-icon" aria-hidden="true">
                                                <RenderIcons iconName="key" />
                                            </div>
                                            <div className="box-title-text">
                                                    <h2 className="box-title">{tLang("validatePassword.title")}</h2>
                                            </div>
                                        </div>
                                        {preferredCommunicationMedia.map((item, index) => {
                                            if (item.methodType === preferredMethod) {
                                                return (
                                                    <div className="box-description">
                                                        <p key={index}>
                                                            {tLang("validatePassword.labels.sentTempCode")}
                                                            <span className="bold">{maskedField(item.recepientAddress)}</span>
                                                        </p>
                                                    </div>
                                                );
                                            }
                                        })}
                                    </div>
                                    <div className="box-content">
                                        <form id="form-forgot-password" onSubmit={handleSubmit(onSubmit)}>
                                            <div className="form-row">
                                                <div className="form-label">
                                                        <label htmlFor="email-label">{tLang("validatePassword.labels.tempVerificationCode")}</label>
                                                </div>
                                                <div className="form-input">
                                                    <input
                                                        type="text"
                                                        className={errors.temporaryPassword ? "status-error inputbox" : "inputbox"}
                                                        ref={register({ required: true })}
                                                        maxLength={8}
                                                        name="temporaryPassword"
                                                        onKeyUp={(e) => handleChange(e)}
                                                        id="email-label"
                                                    />
                                                    {errors.temporaryPassword && errors.temporaryPassword.type === "required" && (
                                                        <span className="form-error">
                                                                <p>{tLang("validatePassword.validationMessages.requiredTempCode")}</p>
                                                        </span>
                                                    )}
                                                </div>
                                            </div>

                                            <div className="margin-bottom-s"></div>

                                            <div className="row between-xs">
                                                <div className="col-xs-12 col-sm col-no-gutter">
                                                    <div className="form-row">
                                                        <button type="submit" className="btn-default btn-primary">
                                                            <span className="btn-text">{tLang("validatePassword.submitBtn")}</span>
                                                        </button>
                                                    </div>
                                                </div>
                                                <div className="col-xs-12 col-sm flex-grow-null col-no-gutter">
                                                    <button
                                                        type="button"
                                                        onClick={() => resendVerificationCode()}
                                                        className="btn-default btn-link btn-no-padding btn-no-border"
                                                    >
                                                            <span className="btn-text">{tLang("validatePassword.labels.resendVerificationCode")}</span>
                                                    </button>
                                                </div>
                                            </div>

                                            {state.errorMessage.length > 0 && (
                                                <div className="form-row row">
                                                    <div className="col-xs-12 col-no-gutter">
                                                        <span className="required">{state.errorMessage}</span>
                                                    </div>
                                                </div>
                                            )}

                                            <div className="form-row">
                                                <button
                                                    type="button"
                                                    className="btn-default btn-link btn-no-padding btn-no-border"
                                                    onClick={() => {
                                                        window.addToDataLayer({ event: "Back to Login" });
                                                        props.history.push("/");
                                                    }}
                                                >
                                                        <span className="btn-text">{tLang("validatePassword.backToLogin")}</span>
                                                </button>
                                            </div>

                                            {!isLife360PartnerId && (
                                                <>
                                                    <div className="line-divider margin-vertical-l"></div>
                                                    <NeedHelp />
                                                </>
                                            )}
                                        </form>
                                    </div>
                                </div>
                            </div>
                        </div>
                    )}
                </div>
            </div>
        </React.Fragment>
    );
};

export default ResetPassword;
